import React, { useState, useEffect, useCallback, useRef } from 'react';
import ClienteConDocumento from '../components/clients/ClienteConDocumento';
import { APIProvider } from '@vis.gl/react-google-maps';
import AddressAutocomplete from '../components/clients/AddressAutocomplete';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Badge } from '../components/ui/badge';
import { Textarea } from '../components/ui/textarea';
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from '../components/ui/table';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '../components/ui/dialog';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../components/ui/select';
import { toast } from 'sonner';
import {
  Plus, Search, Trash2, Loader2, ArrowLeft, CheckCircle2, AlertTriangle, RotateCcw, FileText, Save, RefreshCw, Download,
} from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BASE = `${API}/permessi-soggiorno`;
const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const FIELD_LABELS = {
  cognome: 'Cognome', nome: 'Nome', sesso: 'Sesso', data_nascita: 'Data di nascita',
  luogo_nascita: 'Luogo di nascita', cittadinanza: 'Cittadinanza', numero_documento: 'Numero documento',
  data_rilascio: 'Data di rilascio', data_scadenza: 'Data di scadenza', comune_rilascio: 'Comune di rilascio',
  codice_fiscale: 'Codice fiscale', indirizzo_residenza: 'Indirizzo di residenza', autorita: 'Autorità di rilascio',
  tipo_permesso: 'Tipo di permesso', annotazioni: 'Annotazioni', mrz: 'MRZ',
  // UNILAV (letto dal CRM: utils/unilav.py)
  tipo_comunicazione: 'Tipo comunicazione', data_trasmissione: 'Trasmessa il', codice_comunicazione: 'Codice comunicazione',
  datore_codice_fiscale: 'Datore: codice fiscale / P.IVA', datore_denominazione: 'Datore: denominazione',
  datore_comune_sede: 'Datore: comune sede legale', datore_cap_sede: 'Datore: CAP sede', datore_indirizzo_sede: 'Datore: indirizzo sede',
  datore_pec: 'Datore: e-mail/PEC', legale_cognome: 'Legale rappresentante: cognome', legale_nome: 'Legale rappresentante: nome',
  legale_sesso: 'Legale rappresentante: sesso', legale_data_nascita: 'Legale rappresentante: nato il',
  legale_luogo_nascita: 'Legale rappresentante: luogo di nascita', legale_numero_titolo: 'Legale rappresentante: n. permesso',
  lavoratore_codice_fiscale: 'Lavoratore: codice fiscale', lavoratore_cognome: 'Lavoratore: cognome', lavoratore_nome: 'Lavoratore: nome',
  lavoratore_data_nascita: 'Lavoratore: nato il', lavoratore_numero_titolo: 'Lavoratore: n. permesso',
  lavoratore_comune_domicilio: 'Lavoratore: comune di domicilio', lavoratore_cap_domicilio: 'Lavoratore: CAP domicilio',
  lavoratore_indirizzo_domicilio: 'Lavoratore: indirizzo di domicilio', data_inizio: 'Inizio rapporto', data_fine: 'Fine rapporto',
  tipologia_contrattuale: 'Tipologia contrattuale', tipo_orario: 'Tipo orario', ore_settimanali: 'Ore settimanali',
  lavoro_stagionale: 'Lavoro stagionale', qualifica: 'Qualifica (mansione)', ccnl: 'Contratto collettivo', livello: 'Livello',
  retribuzione: 'Retribuzione annua',
  // Scheda pratica compilata a mano (utils/scheda_pratica.py)
  cliente: 'Scheda: cliente', codice_pratica: 'Scheda: codice pratica', richiede: 'Scheda: richiede il', del_della: 'Scheda: del/della',
  motivo_richiesta: 'Scheda: motivo in richiesta', motivo_altro: 'Scheda: altro motivo (codice)', moduli: 'Scheda: moduli (1 / 2)',
  numero_fogli: 'Scheda: numero totale fogli', figli_carico: 'Scheda: figli a carico', stato_civile: 'Scheda: stato civile',
  rifugiato: 'Scheda: rifugiato', cellulare: 'Scheda: cellulare', email: 'Scheda: e-mail',
  dom_comune: 'Domicilio: comune', dom_provincia: 'Domicilio: provincia', dom_indirizzo: 'Domicilio: indirizzo',
  dom_civico: 'Domicilio: civico', dom_cap: 'Domicilio: CAP', dom_scala: 'Domicilio: scala', dom_interno: 'Domicilio: interno',
  dom_presso: 'Domicilio: presso', coniuge_convivente: 'Conviventi: coniuge', figli_conviventi: 'Conviventi: figli',
  numero_figli_conviventi: 'Conviventi: numero figli', totale_conviventi: 'Conviventi: totale persone', altro_parente: 'Conviventi: altro parente',
  contratto_sui: 'Mod. 2: contratto firmato allo Sportello Unico', prefettura: 'Mod. 2: provincia Prefettura',
  inviato_raccomandata: 'Mod. 2: contratto inviato (raccomandata)', reddito_annuale: 'Mod. 2: reddito annuale percepito',
  importo_annuo: 'Mod. 2: importo annuo €', anno_dichiarazione: 'Mod. 2: anno ultima dichiarazione', cud: 'Mod. 2: CU (CUD)',
  buste_paga: 'Mod. 2: buste paga', bollettini_inps: 'Mod. 2: bollettini INPS', importo_mensile: 'Mod. 2: importo mensile €',
  inizio_att_autonoma: 'Mod. 2: inizio attività autonoma nell\'anno',
  // Visura camerale (lavoro autonomo, Modulo 2 - Sezione 4)
  denominazione: 'Denominazione impresa', forma_giuridica: 'Forma giuridica', partita_iva: 'Partita IVA',
  provincia_cciaa: 'Provincia CCIAA (REA)', numero_rea: 'Numero REA', data_iscrizione: 'Data iscrizione Registro Imprese',
  titolare: 'Titolare', titolare_codice_fiscale: 'Titolare: codice fiscale', albo: 'Iscrizione albi / registri',
  data_albo: 'Data iscrizione albo', sede: 'Sede',
};
// di chi è il documento (fascicolo con i documenti di coniuge e figli): il CRM lo propone, l'operatore può cambiarlo
const PERSONE = {
  richiedente: 'Richiedente', coniuge: 'Coniuge', figlio_1: 'Figlio 1', figlio_2: 'Figlio 2', figlio_3: 'Figlio 3',
  figlio_4: 'Figlio 4', figlio_5: 'Figlio 5', altro: 'Altra persona (non nel modulo)',
};
const STATO_ESTRAZIONE = {
  in_corso: { label: 'Estrazione in corso', className: 'bg-sky-100 text-sky-800' },
  confronto: { label: 'Confronto in corso', className: 'bg-sky-100 text-sky-800' },
  completata: { label: 'Estratto', className: 'bg-emerald-100 text-emerald-800' },
  errore: { label: 'Errore', className: 'bg-red-100 text-red-800' },
};

// il portale non prevede rinnovo e conversione della carta di soggiorno (letto il 14/10/2026)
const NON_PER_CARTA = ['RINNOVO', 'CONVERSIONE'];

// titoletti dei gruppi di campi (UNILAV: prima la ditta, poi il lavoratore, poi il rapporto)
const gruppoCampo = (tipo, nome) => {
  if (!nome) return null;
  if (tipo === 'unilav') {
    if (['tipo_comunicazione', 'data_trasmissione', 'codice_comunicazione'].includes(nome)) return 'COMUNICAZIONE';
    if (nome.startsWith('datore_')) return 'DITTA (DATORE DI LAVORO)';
    if (nome.startsWith('legale_')) return 'DITTA: LEGALE RAPPRESENTANTE / TITOLARE';
    if (nome.startsWith('lavoratore_')) return 'LAVORATORE';
    return 'RAPPORTO DI LAVORO';
  }
  if (tipo === 'scheda') {
    if (nome.startsWith('dom_')) return 'DOMICILIO';
    if (['coniuge_convivente', 'figli_conviventi', 'numero_figli_conviventi', 'totale_conviventi', 'altro_parente'].includes(nome)) return 'FAMILIARI CONVIVENTI';
    if (['contratto_sui', 'prefettura', 'inviato_raccomandata', 'reddito_annuale', 'importo_annuo', 'anno_dichiarazione', 'cud',
      'buste_paga', 'bollettini_inps', 'importo_mensile', 'inizio_att_autonoma'].includes(nome)) return 'LAVORO E REDDITO (MODULO 2)';
    if (['stato_civile', 'rifugiato', 'cellulare', 'email'].includes(nome)) return 'DATI PERSONALI';
    return 'RICHIESTA';
  }
  return null;
};

const errorMessage = (err, fallback) => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (detail?.messaggio) return `${detail.messaggio}: ${(detail.campi || []).join(', ')}`;
  return fallback;
};

// ======================================================================
// Elenco pratiche
// ======================================================================

function ElencoPratiche() {
  const navigate = useNavigate();
  const [pratiche, setPratiche] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [opzioni, setOpzioni] = useState({ richieste: [], del_della: [] });
  const [clients, setClients] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const clienteRef = useRef(null);
  const [creando, setCreando] = useState(false);
  const [form, setForm] = useState({ client_id: '', richiede: 'RINNOVO', del_della: 'PERMESSO SOGGIORNO', provincia_questura: 'PO', note: '' });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(BASE, { params: search ? { search } : {} });
      setPratiche(res.data);
    } catch (err) {
      toast.error(errorMessage(err, 'Errore nel caricamento delle pratiche'));
    } finally {
      setLoading(false);
    }
  }, [search]);

  useEffect(() => {
    const timer = setTimeout(load, 300);
    return () => clearTimeout(timer);
  }, [load]);

  useEffect(() => {
    axios.get(`${BASE}/opzioni`).then((r) => setOpzioni(r.data)).catch(() => {});
  }, []);

  const openNew = async () => {
    setForm({ client_id: '', richiede: 'RINNOVO', del_della: 'PERMESSO SOGGIORNO', provincia_questura: 'PO', note: '' });
    setDialogOpen(true);
    if (!clients.length) {
      try {
        setClients((await axios.get(`${API}/clients`)).data);
      } catch (err) {
        toast.error('Errore nel caricamento dei clienti');
      }
    }
  };

  const create = async () => {
    // come nelle Dimissioni: cliente esistente scelto/abbinato dal documento, oppure nuovo (creato ora)
    setCreando(true);
    const clientId = await clienteRef.current?.conferma();
    if (!clientId) {
      setCreando(false);
      return;
    }
    try {
      const res = await axios.post(BASE, { ...form, client_id: clientId });
      setDialogOpen(false);
      navigate(`/permessi-soggiorno/${res.data.id}`);
    } catch (err) {
      toast.error(errorMessage(err, 'Errore nella creazione della pratica'));
    } finally {
      setCreando(false);
    }
  };


  return (
    <div className="space-y-6 animate-fade-in" data-testid="permessi-soggiorno-page">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-slate-900 tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Permessi di soggiorno
          </h1>
          <p className="text-slate-600 mt-1">
            Lettura dei documenti con il motore locale e dati pronti per il Portale Immigrazione
          </p>
        </div>
        <Button onClick={openNew} data-testid="new-permesso-btn">
          <Plus className="w-4 h-4 mr-2" />
          Nuova Pratica
        </Button>
      </div>

      <Card className="border-slate-200">
        <CardContent className="p-4">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
            <Input placeholder="Cerca per cognome, nome o codice fiscale..." value={search}
              onChange={(e) => setSearch(e.target.value)} className="pl-10" />
          </div>
        </CardContent>
      </Card>

      <Card className="border-slate-200">
        <CardContent className="p-0">
          {loading ? (
            <div className="p-8 text-center text-slate-500">Caricamento...</div>
          ) : pratiche.length === 0 ? (
            <div className="p-8 text-center text-slate-500">Nessuna pratica trovata</div>
          ) : (
            <div className="overflow-x-auto">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Cliente</TableHead>
                    <TableHead>Richiesta</TableHead>
                    <TableHead>Documenti</TableHead>
                    <TableHead>Da controllare</TableHead>
                    <TableHead>Stato</TableHead>
                    <TableHead>Creata il</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {pratiche.map((p) => (
                    <TableRow key={p.id} className="cursor-pointer hover:bg-slate-50"
                      onClick={() => navigate(`/permessi-soggiorno/${p.id}`)}>
                      <TableCell>
                        <div className="font-medium text-slate-900">{p.client_name || '-'}</div>
                        <div className="text-xs text-slate-500 font-mono">{p.client_fiscal_code}</div>
                      </TableCell>
                      <TableCell>{p.richiede} {p.del_della?.toLowerCase()}</TableCell>
                      <TableCell>{p.documenti.length}</TableCell>
                      <TableCell>
                        {p.campi_da_controllare > 0
                          ? <Badge className="bg-amber-100 text-amber-800">{p.campi_da_controllare}</Badge>
                          : <span className="text-slate-400">0</span>}
                      </TableCell>
                      <TableCell>
                        {p.stato === 'confermata'
                          ? <Badge className="bg-emerald-100 text-emerald-800">Confermata</Badge>
                          : <Badge className="bg-slate-100 text-slate-700">In lavorazione</Badge>}
                      </TableCell>
                      <TableCell className="text-sm text-slate-600">
                        {p.created_at ? new Date(p.created_at).toLocaleDateString('it-IT') : ''}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}
        </CardContent>
      </Card>

      <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto uppercase">
          <DialogHeader>
            <DialogTitle>Nuova pratica permesso di soggiorno</DialogTitle>
            <DialogDescription>
              Scegli il cliente o carica il suo documento: se non è in anagrafica lo registro io. I documenti della pratica li carichi dopo, dentro la pratica.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            <ClienteConDocumento ref={clienteRef} clients={clients} setClients={setClients} />
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>Richiede il</Label>
                <Select value={form.richiede} onValueChange={(v) => setForm({ ...form, richiede: v })}>
                  <SelectTrigger><SelectValue /></SelectTrigger>
                  <SelectContent>
                    {opzioni.richieste.map((o) => (
                      <SelectItem key={o} value={o} disabled={form.del_della === 'CARTA SOGGIORNO' && NON_PER_CARTA.includes(o)}>{o}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              <div className="space-y-2">
                <Label>Del/Della</Label>
                <Select value={form.del_della} onValueChange={(v) => setForm({ ...form, del_della: v })}>
                  <SelectTrigger><SelectValue /></SelectTrigger>
                  <SelectContent>
                    {opzioni.del_della.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}
                  </SelectContent>
                </Select>
              </div>
            </div>
            <div className="space-y-2">
              <Label>Provincia della questura (sigla)</Label>
              <Input value={form.provincia_questura} maxLength={2} className="w-24 uppercase"
                onChange={(e) => setForm({ ...form, provincia_questura: e.target.value.toUpperCase() })} />
            </div>
            <div className="space-y-2">
              <Label>Note</Label>
              <Textarea value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} rows={2} />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setDialogOpen(false)}>Annulla</Button>
            <Button onClick={create} disabled={creando}>{creando ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Creo…</> : 'Crea pratica'}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}

// ======================================================================
// Visualizzatore del documento con la zona del campo evidenziata
// ======================================================================

function VisualizzatorePagine({ praticaId, documento, campoAttivo }) {
  const [urls, setUrls] = useState({});
  const [pagina, setPagina] = useState(0);
  const imgRef = useRef(null);
  const [scala, setScala] = useState(null);

  // Le pagine richiedono il login: si scaricano con axios (che ha il token) e si mostrano come blob.
  useEffect(() => {
    let cancelled = false;
    const created = [];
    (async () => {
      const result = {};
      for (let i = 0; i < (documento.pagine || []).length; i++) {
        try {
          const res = await axios.get(`${BASE}/${praticaId}/documenti/${documento.id}/pagine/${i}`, { responseType: 'blob' });
          result[i] = URL.createObjectURL(res.data);
          created.push(result[i]);
        } catch (err) {
          /* pagina non disponibile */
        }
      }
      if (!cancelled) setUrls(result);
    })();
    return () => {
      cancelled = true;
      created.forEach((u) => URL.revokeObjectURL(u));
    };
  }, [praticaId, documento.id, documento.pagine]);

  const campo = campoAttivo ? documento.campi?.[campoAttivo] : null;
  useEffect(() => {
    if (campo && campo.pagina !== null && campo.pagina !== undefined && campo.bbox) setPagina(campo.pagina);
  }, [campo]);

  const aggiornaScala = () => {
    const img = imgRef.current;
    if (img && img.naturalWidth) setScala({ x: img.clientWidth / img.naturalWidth, y: img.clientHeight / img.naturalHeight });
  };
  useEffect(() => {
    window.addEventListener('resize', aggiornaScala);
    return () => window.removeEventListener('resize', aggiornaScala);
  }, []);

  const bbox = campo && campo.bbox && campo.pagina === pagina ? campo.bbox : null;
  const pad = 4;

  return (
    <div className="space-y-2">
      {(documento.pagine || []).length > 1 && (
        <div className="flex gap-2">
          {documento.pagine.map((_, i) => (
            <Button key={i} size="sm" variant={pagina === i ? 'default' : 'outline'} onClick={() => setPagina(i)}>
              Pagina {i + 1}
            </Button>
          ))}
        </div>
      )}
      <div className="relative overflow-hidden rounded border border-slate-200 bg-slate-50">
        {urls[pagina] ? (
          <img ref={imgRef} src={urls[pagina]} alt={`Pagina ${pagina + 1} del documento`}
            className="block w-full h-auto" onLoad={aggiornaScala} />
        ) : (
          <div className="p-8 text-center text-slate-500">Caricamento immagine...</div>
        )}
        {bbox && scala && (
          <div className="absolute pointer-events-none rounded border-[3px] border-pink-600"
            style={{
              left: bbox[0] * scala.x - pad, top: bbox[1] * scala.y - pad,
              width: (bbox[2] - bbox[0]) * scala.x + 2 * pad, height: (bbox[3] - bbox[1]) * scala.y + 2 * pad,
              boxShadow: '0 0 0 9999px rgba(0,0,0,0.25)',
            }} />
        )}
      </div>
      <p className="text-xs text-slate-500">Clicca un campo: la zona da cui è stato letto viene evidenziata.</p>
    </div>
  );
}

// ======================================================================
// Revisione dei campi di un documento
// ======================================================================

function RevisioneDocumento({ pratica, documento, onSaved, modificabile }) {
  const [valori, setValori] = useState({});
  const [campoAttivo, setCampoAttivo] = useState(null);
  const [saving, setSaving] = useState(false);
  const conflitti = pratica.conflitti || {};
  const tipiPerId = Object.fromEntries(pratica.documenti.map((d) => [d.id, d.tipo]));

  useEffect(() => {
    const init = {};
    Object.entries(documento.campi || {}).forEach(([nome, c]) => {
      init[nome] = { valore: c.confermato ?? '', controllato: !!c.controllato };
    });
    setValori(init);
  }, [documento]);

  const salva = async () => {
    setSaving(true);
    try {
      const res = await axios.put(`${BASE}/${pratica.id}/documenti/${documento.id}/campi`, { campi: valori });
      onSaved(res.data);
      toast.success('Salvato: controlli rifatti sui valori');
    } catch (err) {
      toast.error(errorMessage(err, 'Errore nel salvataggio'));
    } finally {
      setSaving(false);
    }
  };

  // MRZ e simili: nascosti (non servono all'operatore, restano per i controlli)
  const campi = Object.entries(documento.campi || {}).filter(([, c]) => !c.nascosto);

  return (
    <div className="grid grid-cols-1 xl:grid-cols-5 gap-6 items-start">
      <div className="xl:col-span-3 xl:sticky xl:top-4">
        <VisualizzatorePagine praticaId={pratica.id} documento={documento} campoAttivo={campoAttivo} />
      </div>
      <div className="xl:col-span-2 space-y-2">
        <div className="flex flex-wrap gap-3 text-xs text-slate-600 mb-2">
          <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-amber-100 border border-amber-400" /> incerto, da controllare</span>
          <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-red-100 border border-red-400" /> in contrasto con un altro documento</span>
          <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-sky-100 border border-sky-400" /> corretto automaticamente</span>
        </div>
        {campi.map(([nome, c], i) => {
          const gruppo = gruppoCampo(documento.tipo, nome);
          const titolo = gruppo && gruppo !== gruppoCampo(documento.tipo, (campi[i - 1] || [])[0]) ? gruppo : null;
          const altri = Object.entries(conflitti[nome] || {}).filter(([id]) => id !== documento.id);
          const inConflitto = !!(conflitti[nome] && conflitti[nome][documento.id] !== undefined);
          const giallo = (c.segnalazioni || []).length > 0;
          const colore = inConflitto ? 'bg-red-50 border-red-300' : giallo ? 'bg-amber-50 border-amber-300' : 'border-transparent';
          const v = valori[nome] || { valore: '', controllato: false };
          return (
            <React.Fragment key={nome}>
            {titolo && <div className="pt-3 pb-1 text-xs font-bold tracking-wide text-slate-500 border-b">{titolo}</div>}
            <div className={`rounded-md border p-3 ${colore}`}
              onClick={() => setCampoAttivo(nome)} onFocus={() => setCampoAttivo(nome)}>
              <Label className="text-xs font-semibold text-slate-700">{FIELD_LABELS[nome] || nome}</Label>
              {nome === 'mrz' ? (
                <Textarea value={v.valore} rows={3} className="font-mono text-xs mt-1" spellCheck={false}
                  disabled={!modificabile}
                  onChange={(e) => setValori({ ...valori, [nome]: { ...v, valore: e.target.value } })} />
              ) : (
                <Input value={v.valore} className="mt-1 bg-white" disabled={!modificabile}
                  onChange={(e) => setValori({ ...valori, [nome]: { ...v, valore: e.target.value } })} />
              )}
              {(c.segnalazioni || []).map((m, i) => <p key={i} className="text-xs text-amber-800 mt-1">{m}</p>)}
              {inConflitto && altri.map(([id, valore]) => (
                <p key={id} className="text-xs text-red-700 font-semibold mt-1">
                  Diverso da {pratica.opzioni_tipi?.[tipiPerId[id]] || tipiPerId[id] || 'altro documento'}: <span className="font-mono">{valore}</span>
                </p>
              ))}
              {(c.correzioni || []).map((m, i) => <p key={i} className="text-xs text-sky-800 mt-1">{m}</p>)}
              {c.letto !== null && c.letto !== undefined && c.letto !== c.confermato && (
                <p className="text-xs text-slate-500 mt-1">Letto dal modello: <span className="font-mono">{c.letto}</span></p>
              )}
              {(giallo || inConflitto) && (
                <label className="flex items-center gap-2 mt-2 text-xs font-semibold text-slate-800">
                  <input type="checkbox" checked={v.controllato} disabled={!modificabile}
                    onChange={(e) => setValori({ ...valori, [nome]: { ...v, controllato: e.target.checked } })} />
                  Ho controllato questo campo sul documento
                </label>
              )}
            </div>
            </React.Fragment>
          );
        })}
        {modificabile && (
          <div className="pt-2">
            <Button onClick={salva} disabled={saving}>
              {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Save className="w-4 h-4 mr-2" />}
              Salva e ricontrolla
            </Button>
            <p className="text-xs text-slate-500 mt-2">
              Un valore modificato perde la spunta: dopo il salvataggio i controlli vengono rifatti.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

// ======================================================================
// Dettaglio pratica
// ======================================================================

// Domicilio scritto a mano: dove abita davvero il cliente (può essere diverso dalla residenza
// della carta d'identità). Nell'XML vale più dell'UNILAV; tutto vuoto = si usa l'UNILAV.
const DOMICILIO_VUOTO = { comune: '', provincia: '', indirizzo: '', civico: '', scala: '', interno: '', cap: '', presso: '' };

// Dati della richiesta che non stanno sui documenti: li sceglie/scrive l'operatore e vanno nell'XML.
const DATI_VUOTI = { aggiornamento_foto: '', moduli: '', stato_civile: '', rifugiato: '', cellulare: '' };

function SceltaBottoni({ valore, opzioni, onChange, disabled }) {
  return (
    <div className="flex flex-wrap gap-1">
      {opzioni.map(([v, etichetta]) => (
        <Button key={v} type="button" size="sm" variant={valore === v ? 'default' : 'outline'} disabled={disabled}
          className="h-8 px-3" onClick={() => onChange(valore === v ? '' : v)}>{etichetta}</Button>
      ))}
    </div>
  );
}

// campo di testo che si salva quando si esce (o con Invio)
function TestoSalvato({ valore, onSalva, disabled, className = 'h-8 w-40', placeholder }) {
  const [v, setV] = useState(valore || '');
  useEffect(() => { setV(valore || ''); }, [valore]);
  const conferma = () => { if (v !== (valore || '')) onSalva(v); };
  return (
    <Input className={className} value={v} disabled={disabled} placeholder={placeholder}
      onChange={(e) => setV(e.target.value)} onBlur={conferma}
      onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); conferma(); } }} />
  );
}

function DatiRichiestaCard({ pratica, onSaved, modificabile }) {
  // Ogni scelta si salva subito (prima c'era un pulsante "Salva dati" a parte e le scelte si perdevano).
  const salvato = { ...DATI_VUOTI, ...(pratica.dati_richiesta || {}) };
  const [cell, setCell] = useState(salvato.cellulare || pratica.client_phone || '');
  const [saving, setSaving] = useState(false);
  useEffect(() => { setCell((pratica.dati_richiesta || {}).cellulare || pratica.client_phone || ''); },
    [pratica.dati_richiesta, pratica.client_phone]);
  const mancano = ['moduli', 'stato_civile', 'rifugiato', 'cellulare'].filter((k) => !salvato[k]);
  const haVisura = (pratica.documenti || []).some((x) => x.tipo === 'visura');
  const haUnilav = (pratica.documenti || []).some((x) => x.tipo === 'unilav');
  const salva = async (modifica) => {
    setSaving(true);
    try {
      onSaved((await axios.put(`${BASE}/${pratica.id}/dati-richiesta`, { ...salvato, cellulare: cell, ...modifica })).data);
      toast.success('Salvato');
    } catch (err) {
      toast.error(errorMessage(err, 'Dato non salvato'), { duration: 8000 });
    } finally {
      setSaving(false);
    }
  };
  const riga = (etichetta, contenuto, k) => (
    <div className="flex flex-wrap items-center gap-2">
      <span className={`text-sm w-44 ${salvato[k] ? 'text-slate-600' : 'text-amber-700 font-medium'}`}>{etichetta}</span>{contenuto}
      {salvato[k] && <CheckCircle2 className="w-4 h-4 text-emerald-600" />}
    </div>
  );
  const scelta = (k, opzioni) => (
    <SceltaBottoni valore={salvato[k]} disabled={!modificabile || saving} opzioni={opzioni} onChange={(v) => salva({ [k]: v })} />
  );
  return (
    <Card className={mancano.length ? 'border-amber-300' : 'border-slate-200'}>
      <CardContent className="p-4 space-y-3">
        <div>
          <h3 className="font-semibold text-slate-900">Dati della richiesta</h3>
          <p className="text-xs text-slate-500">
            {!modificabile ? 'Pratica confermata: riaprila per cambiarli. '
              : mancano.length ? 'Da scegliere: si salvano subito. Non si leggono dai documenti. ' : 'Salvati: vanno nell\'XML per il portale. '}
            Aggiornamento foto: sempre SÌ.
          </p>
        </div>
        {riga('Moduli', scelta('moduli', [['1', 'Solo modulo 1'], ['2', 'Modulo 1 e 2 (lavoro)']]), 'moduli')}
        {riga('Stato civile', scelta('stato_civile', [['LIBERO', 'Libero'], ['CONIUGATO', 'Coniugato/a']]), 'stato_civile')}
        {riga('Rifugiato', scelta('rifugiato', [['NO', 'No'], ['SI', 'Sì']]), 'rifugiato')}
        {riga('Cellulare', (
          <>
            <Input className="h-8 w-48" inputMode="tel" value={cell} disabled={!modificabile || saving}
              onChange={(e) => setCell(e.target.value)} placeholder="es. 3281234567"
              onBlur={() => { if (modificabile && cell !== (salvato.cellulare || '')) salva({ cellulare: cell }); }} />
            {cell !== (salvato.cellulare || '') && modificabile && (
              <Button size="sm" variant="outline" className="h-8" disabled={saving} onClick={() => salva({ cellulare: cell })}>Salva</Button>
            )}
            {salvato.cellulare && <span className="text-xs text-slate-500">nel portale: {salvato.cellulare.slice(0, 3)} / {salvato.cellulare.slice(3)}</span>}
          </>
        ), 'cellulare')}
        {salvato.moduli === '2' && (
          <div className="pt-3 mt-1 border-t space-y-3">
            <div>
              <h4 className="font-semibold text-slate-900 text-sm">Lavoro e reddito (Modulo 2)</h4>
              <p className="text-xs text-slate-500">
                Il reddito (Sezione 5) va compilato qui prima di confermare: segna le X e scrivi gli importi.
              </p>
            </div>
            <p className="text-xs text-slate-600">
              Lavoro: {haVisura && !haUnilav ? 'AUTONOMO TITOLARE (dalla visura)' : haUnilav ? 'SUBORDINATO (dall\'UNILAV)' : 'carica UNILAV (subordinato) o visura (autonomo) nel fascicolo'}
            </p>
            {riga('Reddito annuale percepito', scelta('reddito_annuale', [['SI', 'Sì'], ['NO', 'No']]), 'reddito_annuale')}
            {riga('Importo annuo €', (
              <TestoSalvato valore={salvato.importo_annuo} disabled={!modificabile || saving} placeholder="es. 18500"
                onSalva={(x) => salva({ importo_annuo: x })} />
            ), 'importo_annuo')}
            {riga('Documentazione presentata [D]', scelta('doc_presentata', [
              ['2', 'Modello Unico persone fisiche'], ['3', 'Unico società di persone'],
              ['4', 'Unico società di capitale'], ['5', 'Unico enti non commerciali']]), 'doc_presentata')}
            {riga('Anno ultima dichiarazione', (
              <TestoSalvato valore={salvato.anno_dichiarazione} disabled={!modificabile || saving} className="h-8 w-24" placeholder="es. 2025"
                onSalva={(x) => salva({ anno_dichiarazione: x })} />
            ), 'anno_dichiarazione')}
            <div className="flex flex-wrap items-center gap-2">
              <span className="text-sm w-44 text-slate-600">Documenti presentati (X)</span>
              {[['cud', 'CU (CUD)'], ['buste_paga', 'Buste paga'], ['bollettini_inps', 'Bollettini INPS']].map(([k, et]) => (
                <Button key={k} type="button" size="sm" className="h-8 px-3" disabled={!modificabile || saving}
                  variant={salvato[k] === 'SI' ? 'default' : 'outline'}
                  onClick={() => salva({
                    cud: salvato.cud || 'NO', buste_paga: salvato.buste_paga || 'NO', bollettini_inps: salvato.bollettini_inps || 'NO',
                    [k]: salvato[k] === 'SI' ? 'NO' : 'SI',
                  })}>
                  {salvato[k] === 'SI' ? '☒' : '☐'} {et}
                </Button>
              ))}
            </div>
            {riga('Importo mensile €', (
              <TestoSalvato valore={salvato.importo_mensile} disabled={!modificabile || saving} placeholder="es. 1450"
                onSalva={(x) => salva({ importo_mensile: x })} />
            ), 'importo_mensile')}
            {riga('Inizio attività autonoma nell\'anno', scelta('inizio_att_autonoma', [['NO', 'No'], ['SI', 'Sì']]), 'inizio_att_autonoma')}
          </div>
        )}
      </CardContent>
    </Card>
  );
}

function DomicilioCard({ pratica, onSaved, modificabile }) {
  const [d, setD] = useState({ ...DOMICILIO_VUOTO, ...(pratica.domicilio || {}) });
  const [suggeriti, setSuggeriti] = useState([]);
  const [saving, setSaving] = useState(false);
  useEffect(() => { setD({ ...DOMICILIO_VUOTO, ...(pratica.domicilio || {}) }); }, [pratica.domicilio]);

  const cambia = (k, v) => setD((x) => ({ ...x, [k]: v }));
  // indirizzo scelto da Google Maps (come in anagrafica clienti): compila via, civico, comune, provincia, CAP
  const daGoogle = (g) => setD((x) => ({
    ...x,
    indirizzo: (g.address || x.indirizzo || '').toUpperCase(),
    civico: (g.address_number || x.civico || '').toUpperCase(),
    comune: (g.city || x.comune || '').toUpperCase(),
    provincia: (g.city_provincia || x.provincia || '').toUpperCase(),
    cap: g.postal_code || x.cap,
  }));
  const cercaComune = async (testo) => {
    const scelto = suggeriti.find((c) => `${c.comune} (${c.provincia})` === testo);
    if (scelto) {
      setD((x) => ({ ...x, comune: scelto.comune, provincia: scelto.provincia }));
      return;
    }
    // "PRATO (PO)" (dopo Google Maps o dall'elenco): nome e provincia separati, mai "PRATO (PO)" come nome
    const m = testo.toUpperCase().match(/^(.+?)\s*\(([A-Z]{2})\)\s*$/);
    if (m) {
      setD((x) => ({ ...x, comune: m[1].trim(), provincia: m[2] }));
      return;
    }
    setD((x) => ({ ...x, comune: testo, provincia: '' }));
    if (testo.trim().length < 2) { setSuggeriti([]); return; }
    try {
      setSuggeriti((await axios.get(`${BASE}/comuni`, { params: { q: testo } })).data);
    } catch { setSuggeriti([]); }
  };
  const salva = async (dati) => {
    setSaving(true);
    try {
      onSaved((await axios.put(`${BASE}/${pratica.id}/domicilio`, dati)).data);
      toast.success(Object.values(dati).some((v) => v) ? 'Domicilio salvato' : 'Domicilio tolto: si usa quello dell\'UNILAV');
    } catch (err) {
      toast.error(errorMessage(err, 'Domicilio non salvato'), { duration: 8000 });
    } finally {
      setSaving(false);
    }
  };
  const salvato = { ...DOMICILIO_VUOTO, ...(pratica.domicilio || {}) };
  const modificato = Object.keys(DOMICILIO_VUOTO).some((k) => (d[k] || '') !== (salvato[k] || ''));
  const campo = (k, etichetta, cls, extra = {}) => (
    <div className={cls}>
      <Label className="text-xs text-slate-600">{etichetta}</Label>
      <Input className="h-8" value={d[k]} disabled={!modificabile} onChange={(e) => cambia(k, e.target.value)} {...extra} />
    </div>
  );

  return (
    <Card className={pratica.domicilio ? 'border-slate-200' : 'border-amber-200'}>
      <CardContent className="p-4 space-y-3">
        <div className="flex flex-wrap items-baseline justify-between gap-2">
          <div>
            <h3 className="font-semibold text-slate-900">Domicilio (dove abita)</h3>
            <p className="text-xs text-slate-500">
              {pratica.domicilio
                ? 'Scritto a mano: va nell\'XML al posto di quello dei documenti.'
                : 'Da scrivere a mano se diverso dalla carta d\'identità. Se resta vuoto si usa il domicilio dell\'UNILAV.'}
            </p>
          </div>
          {modificabile && (
            <div className="flex gap-2">
              {pratica.domicilio && (
                <Button size="sm" variant="ghost" disabled={saving} onClick={() => salva(DOMICILIO_VUOTO)}>Togli</Button>
              )}
              <Button size="sm" disabled={saving || !modificato} onClick={() => salva(d)}>Salva domicilio</Button>
            </div>
          )}
        </div>
        {modificabile && GOOGLE_MAPS_API_KEY && (
          <div className="normal-case">
            <Label className="text-xs text-slate-600 uppercase">Cerca indirizzo (Google Maps)</Label>
            <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
              <AddressAutocomplete value="" defaultValue="" placeholder="es. Via Curtatone 17, Prato" onPlaceSelect={daGoogle} />
            </APIProvider>
          </div>
        )}
        <div className="grid grid-cols-2 md:grid-cols-12 gap-2">
          <div className="col-span-2 md:col-span-4">
            <Label className="text-xs text-slate-600">Comune</Label>
            <Input className="h-8" list="comuni-domicilio" disabled={!modificabile}
              value={d.provincia ? `${d.comune} (${d.provincia})` : d.comune}
              onChange={(e) => cercaComune(e.target.value)} placeholder="scrivi e scegli" />
            <datalist id="comuni-domicilio">
              {suggeriti.map((c) => <option key={`${c.comune}-${c.provincia}`} value={`${c.comune} (${c.provincia})`} />)}
            </datalist>
          </div>
          {campo('indirizzo', 'Indirizzo (via/piazza)', 'col-span-2 md:col-span-5', { maxLength: 60, placeholder: 'VIA ...' })}
          {campo('civico', 'Civico', 'md:col-span-1', { maxLength: 10 })}
          {campo('cap', 'CAP', 'md:col-span-2', { maxLength: 5, inputMode: 'numeric' })}
          {campo('scala', 'Scala', 'md:col-span-1', { maxLength: 5 })}
          {campo('interno', 'Interno', 'md:col-span-1', { maxLength: 5 })}
          {campo('presso', 'Presso (se ospite di qualcuno)', 'col-span-2 md:col-span-5', { maxLength: 60, placeholder: 'facoltativo' })}
        </div>
      </CardContent>
    </Card>
  );
}

function DettaglioPratica({ id }) {
  const navigate = useNavigate();
  const [pratica, setPratica] = useState(null);
  const [codiceKit, setCodiceKit] = useState('');
  useEffect(() => { setCodiceKit(pratica?.codice_pratica || ''); }, [pratica?.codice_pratica]);
  const [opzioni, setOpzioni] = useState({ tipi_documento: {} });
  const [docAttivo, setDocAttivo] = useState(null);
  const [addOpen, setAddOpen] = useState(false);
  const [fileScelto, setFileScelto] = useState(null);
  const [caricando, setCaricando] = useState(false);
  const [addForm, setAddForm] = useState({ client_document_id: '', tipo: 'passaporto' });
  const [busy, setBusy] = useState(false);
  const [avvisiXml, setAvvisiXml] = useState(null);

  const load = useCallback(async () => {
    try {
      const res = await axios.get(`${BASE}/${id}`);
      setPratica(res.data);
    } catch (err) {
      toast.error(errorMessage(err, 'Pratica non trovata'));
      navigate('/permessi-soggiorno');
    }
  }, [id, navigate]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    axios.get(`${BASE}/opzioni`).then((r) => setOpzioni(r.data)).catch(() => {});
  }, []);

  // Aggiornamento automatico mentre un documento è in estrazione.
  const inCorso = pratica?.documenti?.some((d) => ['in_corso', 'confronto'].includes(d.stato_estrazione))
    || pratica?.fascicoli?.some((f) => f.stato === 'in_corso');
  useEffect(() => {
    if (!inCorso) return undefined;
    const timer = setInterval(load, 4000);
    return () => clearInterval(timer);
  }, [inCorso, load]);

  useEffect(() => {
    if (pratica && !pratica.documenti.find((d) => d.id === docAttivo)) {
      const primo = pratica.documenti.find((d) => d.stato_estrazione === 'completata');
      setDocAttivo(primo ? primo.id : null);
    }
  }, [pratica, docAttivo]);

  // I documenti si caricano direttamente qui (non dall'anagrafica del cliente).
  const apriAggiungi = () => {
    setFileScelto(null);
    setAddForm({ client_document_id: '', tipo: 'fascicolo' });
    setAddOpen(true);
  };

  const aggiungi = async () => {
    if (!fileScelto) {
      toast.error('Scegli il file');
      return;
    }
    setCaricando(true);
    try {
      const fd = new FormData();
      fd.append('file', fileScelto);
      fd.append('tipo', addForm.tipo);
      setPratica((await axios.post(`${BASE}/${id}/carica`, fd, { timeout: 300000 })).data);
      setAddOpen(false);
      toast.success(addForm.tipo === 'fascicolo'
        ? 'Fascicolo caricato: divisione e riconoscimento delle pagine in corso'
        : 'Documento caricato: lettura avviata');
    } catch (err) {
      toast.error(errorMessage(err, 'Errore nel caricamento del file'));
    } finally {
      setCaricando(false);
    }
  };

  const azione = async (fn, successo) => {
    setBusy(true);
    try {
      const res = await fn();
      if (res?.data?.id) setPratica(res.data);
      if (successo) toast.success(successo);
    } catch (err) {
      toast.error(errorMessage(err, 'Operazione non riuscita'), { duration: 8000 });
    } finally {
      setBusy(false);
    }
  };

  const scaricaXml = async () => {
    setBusy(true);
    try {
      const res = await axios.get(`${BASE}/${id}/xml`);
      const blob = new Blob([res.data.xml], { type: 'application/xml' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = res.data.nome_file;
      a.click();
      URL.revokeObjectURL(url);
      setAvvisiXml(res.data.avvisi || []);
    } catch (err) {
      toast.error(errorMessage(err, 'Errore nella generazione del file XML'));
    } finally {
      setBusy(false);
    }
  };

  if (!pratica) return <div className="p-8 text-center text-slate-500">Caricamento...</div>;

  const confermata = pratica.stato === 'confermata';
  const documento = pratica.documenti.find((d) => d.id === docAttivo);
  const tipi = opzioni.tipi_documento || {};

  return (
    <div className="space-y-6 animate-fade-in uppercase" data-testid="permesso-dettaglio">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div>
          <Button variant="ghost" size="sm" className="mb-2 -ml-2" onClick={() => navigate('/permessi-soggiorno')}>
            <ArrowLeft className="w-4 h-4 mr-1" /> Pratiche
          </Button>
          <h1 className="text-3xl font-bold text-slate-900 tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>
            {pratica.client_name}
          </h1>
          <p className="text-slate-600 mt-1 flex flex-wrap items-center gap-1">
            <select className="h-7 border rounded px-1 text-sm uppercase" value={pratica.richiede} disabled={confermata || busy}
              onChange={(e) => azione(() => axios.put(`${BASE}/${id}`, { richiede: e.target.value, del_della: pratica.del_della,
                provincia_questura: pratica.provincia_questura, note: pratica.note || '' }), 'Tipo di richiesta aggiornato')}>
              {(opzioni.richieste || []).map((o) => (
                <option key={o} value={o} disabled={pratica.del_della === 'CARTA SOGGIORNO' && NON_PER_CARTA.includes(o)}>{o}</option>
              ))}
            </select>
            <select className="h-7 border rounded px-1 text-sm uppercase" value={pratica.del_della} disabled={confermata || busy}
              onChange={(e) => azione(() => axios.put(`${BASE}/${id}`, { richiede: pratica.richiede, del_della: e.target.value,
                provincia_questura: pratica.provincia_questura, note: pratica.note || '' }), 'Tipo di richiesta aggiornato')}>
              {(opzioni.del_della || []).map((o) => <option key={o} value={o}>{o}</option>)}
            </select>
            {pratica.del_della === 'CARTA SOGGIORNO' && NON_PER_CARTA.includes(pratica.richiede) && (
              <span className="text-xs text-red-700">il portale non prevede {pratica.richiede} della carta</span>
            )}
            {pratica.client_fiscal_code ? ` · ${pratica.client_fiscal_code}` : ''}
            {` · Questura ${pratica.provincia_questura}`}
          </p>
          {/* codice pratica/protocollo del kit: lo scrive l'operatore (serve per l'XML del portale) */}
          <div className="flex items-center gap-2 mt-2">
            <span className="text-sm text-slate-600">Codice pratica (kit):</span>
            <Input className="h-8 w-56" maxLength={20} value={codiceKit} placeholder="da inserire"
              onChange={(e) => setCodiceKit(e.target.value)} />
            <Button size="sm" variant="outline" disabled={busy || codiceKit.trim() === (pratica.codice_pratica || '')}
              onClick={() => azione(() => axios.put(`${BASE}/${id}/codice`, { codice_pratica: codiceKit.trim() }), 'Codice pratica salvato')}>
              Salva
            </Button>
            {!pratica.codice_pratica && <span className="text-xs text-amber-700">obbligatorio per scaricare l'XML</span>}
          </div>
        </div>
        <div className="flex flex-wrap gap-2">
          {confermata ? (
            <>
              <Badge className="bg-emerald-100 text-emerald-800 text-sm px-3 py-1">
                <CheckCircle2 className="w-4 h-4 mr-1" /> Confermata da {pratica.confermata_da}
              </Badge>
              <Button disabled={busy || !pratica.codice_pratica} onClick={scaricaXml}
                title={pratica.codice_pratica ? '' : 'Inserisci prima il codice pratica (kit)'}>
                <Download className="w-4 h-4 mr-2" /> Scarica XML per il portale
              </Button>
              <Button variant="outline" disabled={busy}
                onClick={() => azione(() => axios.post(`${BASE}/${id}/riapri`), 'Pratica riaperta')}>
                <RotateCcw className="w-4 h-4 mr-2" /> Riapri
              </Button>
            </>
          ) : (
            <>
              <Button variant="outline" onClick={apriAggiungi}><Plus className="w-4 h-4 mr-2" /> Carica documenti</Button>
              <Button disabled={busy || !pratica.documenti.length}
                onClick={() => azione(() => axios.post(`${BASE}/${id}/conferma`), 'Pratica confermata')}>
                <CheckCircle2 className="w-4 h-4 mr-2" /> Conferma pratica
              </Button>
            </>
          )}
          <Button variant="outline" className="text-red-600" disabled={busy}
            onClick={() => {
              if (window.confirm(`Eliminare la pratica di ${pratica.client_name}?`)) {
                azione(() => axios.delete(`${BASE}/${id}`)).then(() => navigate('/permessi-soggiorno'));
              }
            }}>
            <Trash2 className="w-4 h-4" />
          </Button>
        </div>
      </div>

      {!pratica.validazione_ok && (
        <Card className="border-amber-300 bg-amber-50"><CardContent className="p-4 text-sm text-amber-900 flex gap-2">
          <AlertTriangle className="w-5 h-5 shrink-0" />
          Il motore di estrazione non ha risposto all'ultimo controllo: le segnalazioni potrebbero non essere aggiornate.
          Salva di nuovo o riprova più tardi. La conferma rifà comunque tutti i controlli.
        </CardContent></Card>
      )}
      {Object.keys(pratica.conflitti || {}).length > 0 && (
        <Card className="border-red-300 bg-red-50"><CardContent className="p-4 text-sm text-red-900">
          <strong>Dati in contrasto tra documenti:</strong>{' '}
          {Object.keys(pratica.conflitti).map((c) => FIELD_LABELS[c] || c).join(', ')}.
          Correggi il documento sbagliato, o spunta il campo come controllato.
        </CardContent></Card>
      )}

      <DatiRichiestaCard pratica={pratica} onSaved={setPratica} modificabile={!confermata} />
      <DomicilioCard pratica={pratica} onSaved={setPratica} modificabile={!confermata} />

      {(pratica.fascicoli || []).length > 0 && (
        <div className="space-y-1">
          {pratica.fascicoli.map((f) => (
            <div key={f.id} className={`text-sm rounded-md border px-3 py-2 ${f.stato === 'errore' ? 'border-red-200 bg-red-50 text-red-800' : 'border-slate-200 bg-slate-50 text-slate-700'}`}>
              {f.stato === 'in_corso' && <><Loader2 className="w-4 h-4 mr-1 inline animate-spin" />Fascicolo {f.nome}: divido le pagine e riconosco i documenti…</>}
              {f.stato === 'errore' && <>Fascicolo {f.nome}: {f.errore}</>}
              {f.stato === 'fatto' && (
                <>Fascicolo {f.nome} ({f.pagine} pagine): {(f.riepilogo || []).map((r) => `${tipi[r.tipo] || r.tipo} pag. ${r.pagine.join('-')}`).join(' · ')}
                  {(f.scartate || []).length > 0 && <span className="text-slate-500"> · pagine non riconosciute: {f.scartate.join(', ')}</span>}</>
              )}
            </div>
          ))}
        </div>
      )}

      <Card className="border-slate-200">
        <CardContent className="p-4">
          {pratica.documenti.length === 0 ? (
            <div className="text-center text-slate-500 py-6">
              Nessun documento. Aggiungi dall'anagrafica del cliente il fascicolo con tutti i documenti insieme, oppure i singoli documenti.
            </div>
          ) : (
            <div className="flex flex-wrap gap-2">
              {pratica.documenti.map((d) => {
                const st = STATO_ESTRAZIONE[d.stato_estrazione] || {};
                const daControllare = Object.entries(d.campi || {}).filter(([n, c]) =>
                  ((c.segnalazioni || []).length || (pratica.conflitti?.[n] && pratica.conflitti[n][d.id] !== undefined)) && !c.controllato).length;
                return (
                  <div key={d.id} className={`flex items-center gap-2 rounded-md border px-3 py-2 ${docAttivo === d.id ? 'border-slate-900 bg-slate-50' : 'border-slate-200'}`}>
                    <button type="button" className="flex items-center gap-2 text-left"
                      disabled={d.stato_estrazione !== 'completata'} onClick={() => setDocAttivo(d.id)}>
                      <FileText className="w-4 h-4 text-slate-500" />
                      <span className="font-medium">{tipi[d.tipo] || d.tipo}</span>
                      {d.pagine_fascicolo && <span className="text-xs text-slate-500">pag. {d.pagine_fascicolo.join('-')}</span>}


                      <Badge className={st.className}>
                        {['in_corso', 'confronto'].includes(d.stato_estrazione) && <Loader2 className="w-3 h-3 mr-1 animate-spin" />}
                        {st.label}
                      </Badge>
                      {daControllare > 0 && <Badge className="bg-amber-100 text-amber-800">{daControllare} da controllare</Badge>}
                    </button>
                    {d.stato_estrazione === 'completata' && (
                      <select className={`h-7 border rounded px-1 text-xs ${(d.persona || 'richiedente') === 'richiedente' ? '' : 'bg-violet-50 border-violet-300'}`}
                        value={d.persona || 'richiedente'} disabled={confermata || busy}
                        title={d.persona_manuale ? 'Scelto a mano' : 'Proposto dal CRM'}
                        onChange={(e) => azione(() => axios.put(`${BASE}/${id}/documenti/${d.id}/persona`, { persona: e.target.value }), 'Persona aggiornata')}>
                        {Object.entries(PERSONE).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
                      </select>
                    )}
                    {!confermata && d.stato_estrazione === 'errore' && (
                      <Button size="sm" variant="ghost" title={d.errore}
                        onClick={() => azione(() => axios.post(`${BASE}/${id}/documenti/${d.id}/estrai`), 'Estrazione riavviata')}>
                        <RefreshCw className="w-4 h-4" />
                      </Button>
                    )}
                    {!confermata && (
                      <Button size="sm" variant="ghost" className="text-slate-400 hover:text-red-600"
                        onClick={() => window.confirm('Togliere il documento dalla pratica?') &&
                          azione(() => axios.delete(`${BASE}/${id}/documenti/${d.id}`))}>
                        <Trash2 className="w-4 h-4" />
                      </Button>
                    )}
                  </div>
                );
              })}
            </div>
          )}
          {pratica.documenti.filter((d) => d.stato_estrazione === 'errore').map((d) => (
            <p key={d.id} className="text-sm text-red-700 mt-3">{tipi[d.tipo] || d.tipo}: {d.errore}</p>
          ))}
        </CardContent>
      </Card>

      {documento && (
        <Card className="border-slate-200">
          <CardContent className="p-4">
            <RevisioneDocumento pratica={{ ...pratica, opzioni_tipi: tipi }} documento={documento}
              modificabile={!confermata} onSaved={setPratica} />
          </CardContent>
        </Card>
      )}

      <Dialog open={avvisiXml !== null} onOpenChange={(open) => !open && setAvvisiXml(null)}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle>File XML scaricato</DialogTitle>
            <DialogDescription>
              Importalo nel Portale Immigrazione con "Importa Pratiche", poi apri la pratica importata e
              completa quanto indicato qui sotto. Controlla tutto prima dell'invio.
            </DialogDescription>
          </DialogHeader>
          <ul className="list-disc pl-5 space-y-1 text-sm text-slate-800 max-h-96 overflow-y-auto">
            {(avvisiXml || []).map((a, i) => <li key={i}>{a}</li>)}
          </ul>
          <DialogFooter>
            <Button onClick={() => setAvvisiXml(null)}>Ho capito</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Dialog open={addOpen} onOpenChange={setAddOpen}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle>Carica documenti nella pratica</DialogTitle>
            <DialogDescription>
              Scegli il file dal computer (PDF, JPG o PNG). La lettura avviene sul server dell'ufficio.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            <div className="space-y-2">
              <Label>File</Label>
              <Input type="file" accept="application/pdf,image/jpeg,image/png"
                onChange={(e) => setFileScelto(e.target.files?.[0] || null)} />
              {fileScelto && <p className="text-xs text-slate-500">{fileScelto.name} · {(fileScelto.size / 1024 / 1024).toFixed(1)} MB</p>}
            </div>
            <div className="space-y-2">
              <Label>Tipo di documento</Label>
              <Select value={addForm.tipo} onValueChange={(v) => setAddForm({ ...addForm, tipo: v })}>
                <SelectTrigger><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="fascicolo">Fascicolo: tutti i documenti insieme (li divido e riconosco io)</SelectItem>
                  {Object.entries(tipi).map(([k, label]) => <SelectItem key={k} value={k}>{label}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setAddOpen(false)}>Annulla</Button>
            <Button onClick={aggiungi} disabled={!fileScelto || caricando}>
              {caricando ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Caricamento…</> : 'Carica e leggi'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default function PermessiSoggiorno() {
  const { id } = useParams();
  return id ? <DettaglioPratica id={id} /> : <ElencoPratiche />;
}
